import { FONT_SIZE_LABEL } from '../../utils';

export default class Message {
    text = '';
    fontSize = FONT_SIZE_LABEL.MEDIUM;
}
